module.exports = __webpack_public_path__ + "media/images/new/icons/pinterest@2x-8d3d6872261724479e63a0f282a53ebb.png";